import React from "react";
import academy1 from "./images/2_academy/academy_1.png";
import academy2 from "./images/2_academy/ACADEMY2.png";
import academy3 from "./images/2_academy/ACADEMY3.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Academy = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyItems: "center",
        alignItems: "center",
        marginTop: 30,
      }}
    >
      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            style={{ width: "70%" }}
            src={academy1}
            alt={"academy photo 1"}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "black",
          paddingLeft: 10,
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "right",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          BECOME ONE OF THE BEST LEARNING FROM THE BEST
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            textAlign: "right",
            marginBottom: 30,
            maxWidth: "70%",
            fontSize: TEXT_FONT_SIZE,
            marginRight: "20%",
          }}
        >
          Every time you launch this app, you’ll be uncovering something new to
          help your game. Whether you are building your arsenal, beginning a new
          journey with a coach, or watching a new video featuring our team -
          it’s all at the tip of your fingers!
        </div>
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              fontFamily: "OswaldBoldItalic",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              style={{ width: "40%", marginRight: 20 }}
              src={academy2}
              alt={"Academy photo 2"}
            />
            <img
              style={{ width: "40%" }}
              src={academy3}
              alt={"Academy photo 3"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Academy;
